module.exports = __webpack_public_path__ + "media/images/new_culture/bg-3-a631df7b75938de7df2d60e4e3f5f97b.jpeg";